import type { AuthImage } from '@concord/ui';
import clinic from '../../assets/sign-in-clinic.webp';
import consoleDesk from '../../assets/sign-in-console.webp';

/**
 * Sign-in photos, one per side of the product so staff and patients can tell at a glance
 * where they are. Both from Pexels under the Pexels license (free, no attribution required;
 * credited anyway), self-hosted because the CSP allows same-origin images only.
 */
export const AUTH_IMAGES: Record<'patient' | 'staff', AuthImage> = {
  /** Pexels 7578797, "A Doctor Sitting at a Desk" by cottonbro studio. */
  patient: {
    src: clinic,
    caption: 'Specialist opinions from a panel of cancer physicians, arranged around you.',
    credit: 'Photo: cottonbro studio / Pexels',
  },
  /** Pexels 7195110, "Woman With Stethoscope Using a Laptop" by Kaboompics. */
  staff: {
    src: consoleDesk,
    caption: 'The care navigator console: every case, panel and consultation in one place.',
    credit: 'Photo: Kaboompics / Pexels',
  },
};
